module.exports = __webpack_public_path__ + "static/CircularPro-BookItalic.7ae8de65.ttf";


//////////////////
// WEBPACK FOOTER
// ./public/fonts/CircularPro-BookItalic.ttf
// module id = 648
// module chunks = 168707334958949